
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12C23.993 5.376 18.624.007 12 0zm10.378 16.204l-3.412.589c.39-1.433.601-2.908.628-4.393h3.596a11.125 11.125 0 01-.812 3.804zM.81 12.4h3.596c.027 1.485.238 2.96.628 4.393l-3.412-.59A11.125 11.125 0 01.81 12.4zm.812-4.604l3.412-.589a17.907 17.907 0 00-.628 4.393H.81c.045-1.306.32-2.594.812-3.804zM12.4 6.422c1.437.019 2.871.15 4.288.392l1.412.244c.434 1.476.667 3.004.694 4.542H12.4V6.422zm4.424-.396a28.353 28.353 0 00-4.424-.404v-4.8c2.293.22 4.285 2.32 5.414 5.376l-.99-.172zM11.6 5.622a28.348 28.348 0 00-4.424.404l-.99.17C7.315 3.14 9.306 1.04 11.6.822v4.801zM7.312 6.814a27.51 27.51 0 014.288-.392V11.6H5.206A17.17 17.17 0 015.9 7.058l1.412-.244zM5.206 12.4H11.6v5.178a27.508 27.508 0 01-4.288-.392L5.9 16.942a17.17 17.17 0 01-.694-4.542zm1.97 5.574c1.461.25 2.94.386 4.424.406v4.8c-2.293-.22-4.285-2.32-5.414-5.376l.99.17zm5.224.406a28.441 28.441 0 004.424-.406l.99-.17c-1.129 3.056-3.12 5.156-5.414 5.375v-4.8zm4.288-1.194c-1.417.242-2.85.373-4.288.392V12.4h6.394a17.167 17.167 0 01-.694 4.542l-1.412.244zm2.906-5.586a17.905 17.905 0 00-.628-4.393l3.412.59c.492 1.21.767 2.497.812 3.803h-3.596zm2.38-4.686l-3.272-.564a11.029 11.029 0 00-3.182-4.98 11.253 11.253 0 016.454 5.544zM8.48 1.37a11.03 11.03 0 00-3.182 4.98l-3.272.564A11.253 11.253 0 018.48 1.37zM2.026 17.085l3.272.565a11.03 11.03 0 003.182 4.98 11.253 11.253 0 01-6.454-5.544zM15.52 22.63a11.03 11.03 0 003.182-4.98l3.272-.564a11.253 11.253 0 01-6.454 5.544z","fill":"#00003C"}})])
          )
        }
      }
    